import React, { useState, useRef } from "react";
import RcListView from "./RcListView";
import RcPoView from "./RcPoView";
import RcCreatePage from "./RcCreatePage";

const RateContract = () => {
    const [selectedContract, setSelectedContract] = useState(null);
    const [createRc, setCreateRc] = useState(false);
    const [viewPo, setViewPo] = useState(false);
    const [loading, setLoading] = useState(false);
    const rcInputRef = useRef(null);
    const [savedRc, setSavedRc] = useState(null);

    const handleAddRc = () => setCreateRc(true);
    const handleBackToHome = () => {
        setCreateRc(false);
        setViewPo(false);
        setSelectedContract(null);
    };

    const handleViewPo = (contract) => {
        setSelectedContract(contract);
        setViewPo(true);
    };

    const handleSaveRc = (newSavedRc) => {
        setSavedRc(newSavedRc);
        setCreateRc(false);
    };

    return (
        <>
            { !createRc && !viewPo && (
                <RcListView
                    onAddRc={ handleAddRc }
                    onViewPo={ handleViewPo }
                    savedRc={ savedRc }
                />
            ) }

            { viewPo && selectedContract && (
                <RcPoView
                    selectedContract={ selectedContract }
                    onBack={ handleBackToHome }
                    rcInputRef={ rcInputRef }
                    loading={ loading }
                    setLoading={ setLoading }
                />
            ) }

            { createRc && (
                <RcCreatePage
                    onBack={ handleBackToHome }
                    rcInputRef={ rcInputRef }
                    loading={ loading }
                    setLoading={ setLoading }
                    onSave={ handleSaveRc }
                />
            ) }
        </>
    );
};

export default RateContract;
